import React, { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';

export default function AcceptInvite() {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { setError('Passwords do not match'); return; }
    if (password.length < 8) { setError('Password must be at least 8 characters'); return; }
    setLoading(true);
    try {
      await axios.post('/api/auth/accept-invite', { token, password });
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Invalid or expired invite link');
    } finally {
      setLoading(false);
    }
  };

  if (!token) return (
    <div style={{ minHeight: '100vh', background: '#0C447C', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ background: '#fff', borderRadius: '16px', padding: '40px', maxWidth: '400px', textAlign: 'center' }}>
        <p style={{ color: '#A32D2D' }}>Invalid invite link. Please contact your manager.</p>
      </div>
    </div>
  );

  return (
    <div style={{ minHeight: '100vh', background: '#0C447C', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
      <div style={{ background: '#fff', borderRadius: '16px', padding: '40px', width: '100%', maxWidth: '400px' }}>
        {done ? (
          <div style={{ textAlign: 'center' }}>
            <div style={{ width: '56px', height: '56px', borderRadius: '50%', background: '#EAF3DE', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#3B6D11" strokeWidth="2"><path d="M20 6L9 17l-5-5"/></svg>
            </div>
            <h2 style={{ color: '#0C447C', marginBottom: '8px' }}>Account activated!</h2>
            <p style={{ color: '#888', fontSize: '13px', marginBottom: '24px' }}>You can now sign in with your email and password.</p>
            <button onClick={() => navigate('/login')} style={{ background: '#0C447C', color: '#fff', border: 'none', borderRadius: '8px', padding: '10px 24px', fontSize: '14px', cursor: 'pointer' }}>
              Go to login
            </button>
          </div>
        ) : (
          <>
            <h1 style={{ fontSize: '20px', fontWeight: '600', color: '#0C447C', marginBottom: '8px' }}>Set your password</h1>
            <p style={{ fontSize: '13px', color: '#888', marginBottom: '24px' }}>Choose a password to activate your account.</p>
            {error && <div style={{ background: '#FCEBEB', border: '1px solid #F09595', borderRadius: '8px', padding: '10px 14px', fontSize: '13px', color: '#A32D2D', marginBottom: '16px' }}>{error}</div>}
            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom: '16px' }}>
                <label style={{ display: 'block', fontSize: '12px', fontWeight: '500', color: '#666', marginBottom: '6px' }}>New password</label>
                <input type="password" value={password} onChange={e => setPassword(e.target.value)} required placeholder="Minimum 8 characters"
                  style={{ width: '100%', padding: '10px 12px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }} />
              </div>
              <div style={{ marginBottom: '24px' }}>
                <label style={{ display: 'block', fontSize: '12px', fontWeight: '500', color: '#666', marginBottom: '6px' }}>Confirm password</label>
                <input type="password" value={confirm} onChange={e => setConfirm(e.target.value)} required placeholder="Repeat password"
                  style={{ width: '100%', padding: '10px 12px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }} />
              </div>
              <button type="submit" disabled={loading} style={{ width: '100%', padding: '12px', background: loading ? '#888' : '#0C447C', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '14px', fontWeight: '600', cursor: 'pointer' }}>
                {loading ? 'Activating...' : 'Activate account'}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
